import HTTP from './HTTP'
import Armazenamento from './Armazenamento'

const simulacaCalcularUrl = 'simulacao/calcular'
const CEP_WS = (cep) => `https://viacep.com.br/ws/${cep}/json`
const CIDADES_API = (estadoId) => `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoId}/municipios`
const ESTADOS_API = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados'

const servicos = {
  descricoes: {
    buscar: 'descricoes/buscar',
    listar: 'descricoes/listar'
  },
  listar: {
    animais: 'animais/listar',
    estados: 'estados/listar',
    simulacoes: 'simulacao/listar',
    temporeal: 'relatorio/tempo-real/listar'
  },
  simulacao: {
    usuario: {
      quantidade: 'simulacao/usuario/quantidade'
    },
    remover: 'simulacao/remover',
    buscar: 'simulacao/buscar',
    calcular: {
      pasto: {
        basico: `${simulacaCalcularUrl}/pasto-basico`,
        avancado: `${simulacaCalcularUrl}/pasto-avancado`
      },
      confinamento: {
        basico: `${simulacaCalcularUrl}/confinamento-basico`,
        avancado: `${simulacaCalcularUrl}/confinamento-avancado`
      },
      relatorio: {
        tempoReal: 'relatorio/tempo-real/calcular',
        exportarXLSX: 'relatorio/exportarXLSX'
      }
    }
  },
  usuario: {
    buscar: 'usuario',
    atualizar: 'usuario/atualizar'
  },
  cupom: {
    validar: 'cupom/validar'
  },
  assinatura: {
    buscar: {
      usuario: 'assinatura/usuario',
      valor: 'assinatura/valor'
    },
    atualizar: 'assinatura/atualizar',
    listar: 'assinatura/listar',
    extrato: 'assinatura/extrato'
  }
}

const recuperar = (api) => {
  return HTTP.backendGet(api)
    .then(response => response.data)
}

const listar = (cache, api) => {
  if (!cache || cache.expirado) {
    return recuperar(api)
  } else {
    return Promise.resolve(cache.valor)
  }
}

const listarTempoReal = () => {
  return listar(null, servicos.listar.temporeal)
    .then(dados => {
      return dados
    })
}

const listarAnimais = () => {
  return listar(Armazenamento.animais.pegar(), servicos.listar.animais)
    .then(dados => {
      // Valor recuperado do servidor e vamos fazer cache.
      if (dados.animais) {
        Armazenamento.animais.gravar(dados.animais)
        return dados.animais
      }
      // Valor recuperado do cache
      return dados
    })
}

const listarDescricoes = () => {
  return listar(Armazenamento.descricoes.pegar(), servicos.descricoes.listar)
    .then(dados => {
      // Valor recuperado do servidor e vamos fazer cache.
      if (dados.descricoes) {
        Armazenamento.descricoes.gravar(dados.descricoes)
        return dados.descricoes
      }
      // Valor recuperado do cache
      return dados
    })
}

const listarEstados = () => {
  return listar(Armazenamento.estados.pegar(), servicos.listar.estados)
    .then(dados => {
      // Valor recuperado do servidor e vamos fazer cache.
      if (dados.estados) {
        Armazenamento.estados.gravar(dados.estados)
        return dados.estados
      }
      // Valor recuperado do cache
      return dados
    })
}

const calcular = (servico, dados) => {
  return HTTP.backendPost(servico, dados)
}

const buscar = (servico, id) => {
  return HTTP.backendGet(`${servico}/${id}`)
}

const remover = (servico, id) => {
  return HTTP.backendDelete(`${servico}/${id}`)
}

const simulacaoQuantidade = (servico, id) => {
  return HTTP.backendGet(`${servico}/${id}`)
}

const simulacoes = () => {
  return HTTP.backendGet(servicos.listar.simulacoes)
}

const buscarCEP = (cep) => {
  return HTTP.get(CEP_WS(cep))
}

const buscarEstados = () => {
  return HTTP.get(ESTADOS_API)
}

const gerarRelatorio = (servico, id, tipo) => {
  return HTTP.backendGetTypeBlob(`${servico}/${id}/${tipo}`)
}

const buscarCidades = (uf) => {
  return buscarEstados()
    .then(response => {
      if (response.status === 200 && response.data) {
        const estadoId = response.data.find(estado => estado.sigla === uf).id
        return HTTP.get(CIDADES_API(estadoId))
      } else {
        return Promise.reject(response)
      }
    })
}

export default {
  CEP: buscarCEP,
  ESTADOS: buscarEstados,
  CIDADES: buscarCidades,
  servicos,
  descricoes: {
    buscar: (tipo) => buscar(servicos.descricoes.buscar, tipo)
  },
  listar: {
    animais: listarAnimais,
    descricoes: listarDescricoes,
    estados: listarEstados,
    tempoReal: listarTempoReal
  },
  simulacao: {
    usuario: {
      quantidade: (id) => simulacaoQuantidade(servicos.simulacao.usuario.quantidade, id)
    },
    remover: (id) => remover(servicos.simulacao.remover, id),
    buscar: (id) => buscar(servicos.simulacao.buscar, id),
    listar: simulacoes,
    calcular: {
      pasto: {
        basico: (dados) => calcular(servicos.simulacao.calcular.pasto.basico, dados),
        avancado: (dados) => calcular(servicos.simulacao.calcular.pasto.avancado, dados)
      },
      confinamento: {
        basico: (dados) => calcular(servicos.simulacao.calcular.confinamento.basico, dados),
        avancado: (dados) => calcular(servicos.simulacao.calcular.confinamento.avancado, dados)
      },
      relatorio: {
        tempoReal: (dados) => calcular(servicos.simulacao.calcular.relatorio.tempoReal, dados),
        exportarXLSX: (id, tipo) => gerarRelatorio(servicos.simulacao.calcular.relatorio.exportarXLSX, id, tipo)
      }
    }
  },
  usuario: {
    buscar: () => HTTP.backendGet(servicos.usuario.buscar),
    atualizar: (dados) => HTTP.backendPost(servicos.usuario.atualizar, dados)
  },
  cupom: {
    validar: (cupom) => HTTP.backendPost(servicos.cupom.validar, { codigo: cupom })
  },
  assinatura: {
    buscar: (usuarioId) => HTTP.backendGet(`${servicos.assinatura.buscar.usuario}/${usuarioId}`),
    atualizar: (id, status) => HTTP.backendPost(servicos.assinatura.atualizar, { id, status }),
    listar: () => HTTP.backendGet(servicos.assinatura.listar),
    extrato: (assinaturaId) => HTTP.backendGet(`${servicos.assinatura.extrato}/${assinaturaId}`),
    valor: () => HTTP.backendGet(servicos.assinatura.buscar.valor)

  }
}



// WEBPACK FOOTER //
// ./src/services/API.js